import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const jobAuditService = {
  getAudits: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}/audits`);
    return response.data;
  },
};
